import { swoopAPI } from '@/api'

export const getBankMandateList = companyId => swoopAPI.get(`/api/v1/bankMandate/${companyId}/list`)
export const deleteBankMandate = bankMandateId => swoopAPI.delete(`/api/v1/bankMandate/${bankMandateId}`)
